import type { AppEnvironment } from './environment.model';
import {
  DEVELOPMENT_CORS_ORIGINS,
  corsOriginsToEnv,
} from './cors-origins';

/**
 * Staging / shared development environment (Cloudflare preview builds).
 * Align URLs with `apps/marketing/.env.development`.
 */
export const environment: AppEnvironment = {
  production: false,
  appEnv: 'development',
  apiUrl: 'https://api.xcore.bz',
  marketingUrl: 'https://dev-booking.clinic.com',
  corsOrigins: DEVELOPMENT_CORS_ORIGINS,
  corsOriginsEnv: corsOriginsToEnv(DEVELOPMENT_CORS_ORIGINS),
};
